/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockedStockupItemRequestStockupItem
 */
export interface StockedStockupItemRequestStockupItem {
    /**
     * 
     * @type {number}
     * @memberof StockedStockupItemRequestStockupItem
     */
    quantity: number;
}

/**
 * Check if a given object implements the StockedStockupItemRequestStockupItem interface.
 */
export function instanceOfStockedStockupItemRequestStockupItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function StockedStockupItemRequestStockupItemFromJSON(json: any): StockedStockupItemRequestStockupItem {
    return StockedStockupItemRequestStockupItemFromJSONTyped(json, false);
}

export function StockedStockupItemRequestStockupItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockedStockupItemRequestStockupItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
    };
}

export function StockedStockupItemRequestStockupItemToJSON(value?: StockedStockupItemRequestStockupItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantity': value.quantity,
    };
}

